module.exports = __webpack_public_path__ + "static/img/Taille des coupes.369cccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Taille des coupes.png
// module id = D1dB
// module chunks = 1